import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getUUID } from 'utils/utils';

interface Props {
    userId: number | null
    serviceId: number | null
    resourceTypeId: number | null
    resourceIds: number[] | null
    roleIds: number[] | null
}

const initialState: Props = {
    userId: null,
    serviceId: null,
    resourceTypeId: null,
    resourceIds: null,
    roleIds: null,
};

const modalStateSlice = createSlice({
    name: 'PermissionFilter',
    initialState,
    reducers: {
        setAVPEditPermissionFilter: (state, action: PayloadAction<Props>) => {
            Object.assign(state, action.payload);
        },
        resetAVPEditPermissionFilter: (state) => {
            Object.assign(state, initialState);
        },
        setAVPEditPermissionFilterUserId: (state, action: PayloadAction<number>) => {
            state.userId = action.payload;
        },
        setAVPEditPermissionFilterServiceId: (state, action: PayloadAction<number>) => {
            state.serviceId = action.payload;
        },
        setAVPEditPermissionFilterResourceTypeId: (state, action: PayloadAction<number>) => {
            state.resourceTypeId = action.payload;
        },
        setAVPEditPermissionFilterResourceIds: (state, action: PayloadAction<number[]>) => {
            state.resourceIds = action.payload;
        },
        setAVPEditPermissionFilterRoleIds: (state, action: PayloadAction<number[]>) => {
            state.roleIds = action.payload;
        }

    },
});

export const { setAVPEditPermissionFilter, resetAVPEditPermissionFilter, setAVPEditPermissionFilterUserId, setAVPEditPermissionFilterServiceId, setAVPEditPermissionFilterResourceTypeId, setAVPEditPermissionFilterResourceIds, setAVPEditPermissionFilterRoleIds } = modalStateSlice.actions;
export default modalStateSlice.reducer;
